import { TemporaryAccessDetails } from "../temporary-access/TemporaryAccessDetails";

export const temporaryAccessDetails = new TemporaryAccessDetails();
